module.exports = __webpack_public_path__ + "media/images/gallery/constellations/oc_layer_off-7c12a6adb47b85f7bd2308042d27d5d1.jpg";